import styled from "@emotion/styled";


export const LabelWrapper = styled.div<{ theme: Theme }>`
  display: flex;
  justify-content: center;
  gap: 4px;
  padding: 16px 0;
  margin: 0 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};

  img {
    width: 24px;
    height: 24px;
  }
`;

export const CouponDetailsWrapper = styled.div<{ theme: Theme }>`
  display: flex;
  gap: 16px;
  padding: 16px 0;
  margin: 0 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};
`;

export const LogoWrapper = styled.div`
  height: 64px;
  width: 64px;

  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const TnCWrapper = styled.div<{ theme: Theme }>`
  padding: 16px 0;
  margin: 0 20px;
`;

export const TncList = styled.ul`
  padding: 8px 0 0 16px;
`;

export const TnCListItem = styled.li<{ theme: Theme }>`
  font-size: ${({ theme }) => theme.typography.type120.fontSize};
  font-weight: ${({ theme }) => theme.typography.type120.fontWeight};
  line-height: ${({ theme }) => theme.typography.type120.lineHeight};
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: 2px;
`;

export const CouponCodeWrapper = styled.div<{ theme: Theme }>`
  padding: 4px 20px;
  background: ${({ theme }) => theme.colors.couponBg};
  border: 1px dashed ${({ theme }) => theme.colors.couponBorderColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FooterWrapper = styled.div`
  padding: 16px 20px;
`;
